import "./App.css";
import { useTranslations } from "@unleashed/hooks/useTranslations";
import {
  AuthenticationGuard
} from "./features/core/components/AuthenticationGuard";
import {
  AuthorizationGuard
} from "./features/core/components/AuthorizationGuard";
import { Outlet } from "react-router-dom";
import { Suspense } from "react";
import {
  SuspenseFallback
} from "./features/core/features/loading/components/SuspenseFallback";
import {
  Notifications
} from "./features/core/features/notifications/components/Notifications";
import { ApiShade } from "./features/core/features/loading/components/ApiShade";
import {
  EnvironmentLabel
} from "./features/core/features/environment/components/EnvironmentLabel";
import { IdleGuard } from "./features/core/components/IdleGuard";
import { AdminConfig } from "./features/core/components/AdminConfig";
import {
  NotificationsModal
} from "./features/core/components/NotificationsModal";

export function App() {
  const translationsInitialized = useTranslations();

  if (!translationsInitialized) {
    return null;
  }

  return (
    <>
      <AuthenticationGuard>
        <AuthorizationGuard>
          <AdminConfig>
            <IdleGuard>
              <NotificationsModal/>
              <Suspense fallback={<SuspenseFallback/>}>
                <Outlet/>
              </Suspense>
            </IdleGuard>
          </AdminConfig>
        </AuthorizationGuard>
      </AuthenticationGuard>
      <ApiShade/>
      <Notifications/>
      <EnvironmentLabel/>
    </>
  );
}
